export default "__VITE_ASSET__fIEmDEV7__"